import { DetailedHTMLProps, ForwardedRef, InputHTMLAttributes, ReactNode } from 'react';
import { classNames } from '../../helpers/classNames';

interface Props extends DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  hasError?: boolean;
  readOnly?: boolean;
  fullWidth?: boolean;
  rightButton?: ReactNode;
  rightButtonWidth?: number;
  ref?: ForwardedRef<HTMLInputElement>;
}

export const FormInput = ({
  ref,
  className,
  hasError,
  fullWidth,
  rightButton,
  rightButtonWidth,
  readOnly,
  ...inputProps
}: Props) => {
  return (
    <div className={classNames('relative', className)}>
      <input
        ref={ref}
        readOnly={readOnly}
        className={classNames(
          'block w-full rounded-md py-2 pr-3 pl-3 focus:outline-hidden sm:text-sm',
          'rounded-md border border-gray-200 shadow-xs',
          hasError
            ? 'border-red-300 text-red-900 placeholder-red-400 focus:border-red-500 focus:ring-red-500'
            : 'border-gray-300 text-gray-900 placeholder-gray-400 focus:border-blue-600 focus:ring-blue-700',
          inputProps.disabled && 'cursor-not-allowed bg-gray-100',
          fullWidth ? 'w-full' : 'w-auto',
        )}
        aria-invalid={hasError}
        aria-describedby={`${inputProps.name}-error`}
        {...inputProps}
      />
      {rightButton ? (
        <div
          className={classNames(
            'absolute inset-y-0 right-0 flex items-center pr-3',
            hasError ? 'mr-7 text-red-900' : '',
            rightButtonWidth ? ` w-[${rightButtonWidth}px]` : '',
          )}
        >
          {rightButton}
        </div>
      ) : null}
      {hasError && (
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
          <i className="fa-solid fa-warning fa-xl text-red-300" aria-hidden="true" />
        </div>
      )}
    </div>
  );
};
